var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", [
    _c(
      "section",
      {
        staticClass: "tabs content-wrapper",
        class: {
          "utility-hidden": _vm.enableSupplierFocusedSearch,
        },
      },
      [
        _c(
          "ul",
          _vm._l(_vm.tabs, function (tab, index) {
            return _c("li", { key: index }, [
              _c(
                "button",
                {
                  staticClass: "tabs-nav-item",
                  class: {
                    "is-active": tab.isActive,
                    "is-tab2": tab.isTab2,
                  },
                  attrs: { role: "tab" },
                  on: {
                    click: function ($event) {
                      return _vm.selectTab(tab)
                    },
                  },
                },
                [_vm._v("\n          " + _vm._s(tab.name) + "\n        ")]
              ),
            ])
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("section", { staticClass: "tabs-details" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }